import { render, staticRenderFns } from "./header-i18n.vue?vue&type=template&id=15ed5406&scoped=true&"
import script from "./header-i18n.vue?vue&type=script&lang=js&"
export * from "./header-i18n.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed5406",
  null
  
)

export default component.exports